module.exports = __webpack_public_path__ + "img/eco-efemerides-cel.84b0d6f1.png";